import React from "react";
import AuthLayout from "../components/auth/AuthLayout";
import SignupFormContent from "../components/auth/SignupFormContent";

export default function SignupPage() {
  return (
    <AuthLayout>
      <SignupFormContent />
    </AuthLayout>
  );
}
